export const tabs = [
    {
        path: "/availabledividend",
        className: "availabledividend",
        label: "Éves osztalék"
    },
    {
        path: "/dividend",
        className: "dividend",
        label: "Osztalék"
    }
];